import { clsx } from "clsx";
import { ReactNode } from "react";

import styles from "./badge.module.scss";

type BadgeVariant = "success" | "warning" | "danger" | "info" | "neutral";

type BadgeProps = {
  children: ReactNode;
  variant?: BadgeVariant;
  className?: string;
};

const Badge = ({ children, variant = "neutral", className }: BadgeProps) => (
  <span className={clsx(styles.badge, styles[variant], className)}>
    {children}
  </span>
);

export default Badge;
